import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=f4243a1a&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4243a1a')) {
      api.createRecord('f4243a1a', component.options)
    } else {
      api.reload('f4243a1a', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=f4243a1a&", function () {
      api.rerender('f4243a1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZcGYy39i5V5m/JS/offershelp.vue"
export default component.exports